import * as _ from 'lodash';

import { Entity } from './type';
import { Role } from './enum';
import { IFormElemOptions, IFormElemInputOptions } from './interface';

export class EntitySetting {
    public entity: Entity = 'company';
    public id: number | string;

    constructor(entity: Entity, entityID: string | number) {
        this.entity = entity || this.entity;
        this.id = entityID || 0;
    }
    public getKey(type: string) {
        type = type || 'main'; // get main key when not specified
        switch (this.entity) {
            case 'advertiser':
            case 'company':
            default:
                return this.entity.concat('.settings.', `${this.id}`, '.', type);
        }
    }
    public getTypeFromKey(key) {
        return key.replace(
            new RegExp('^(?:' + this.entity + '\\.settings\\.\\w+\\.)(\\w+)$', 'i'), // escape all back-slashes
            '$1'
        );
    }
}

// tslint:disable-next-line: max-classes-per-file
export class Permission {
    public isReadable: () => boolean;
    public isWritable: () => boolean;
    constructor(opts?: { readable?, writable?}) {
        this.isReadable = () => !!opts.readable;
        this.isWritable = () => !!opts.writable;
    }
}

//////////////////////////////////////
/////////////// FORMS ////////////////
//////////////////////////////////////

// tslint:disable-next-line: max-classes-per-file
export class FormElementBase<T>{
    public value: T;
    public key: string;
    public label: string;
    public required: boolean;
    public disabled: boolean;
    public order: number;
    public min: number;
    public max: number;
    public controlType: string;

    constructor(options: IFormElemOptions<T>) {
        this.key = options.key;
        this.value = options.value;
        this.label = options.label || '';
        this.required = !!options.required;
        this.disabled = !!options.disabled;
        this.order = options.order === undefined ? 1 : options.order;
        this.min = options.min || 0;
        this.max = options.max || 9999999999;
        this.controlType = options.controlType || '';
    }

    // public attr(key, val) {
    //     this[key] = val;
    //     return this;
    // }
}

// tslint:disable-next-line: max-classes-per-file
export class FormInput extends FormElementBase<string> {
    public controlType = 'input';
    public type = 'text';

    constructor(options: IFormElemInputOptions) {
        super(options);
        this.type = options.type || this.type;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/classes.ts